import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import DataTable from "./DataTable";
import { useNavigate } from "react-router-dom";
import { ApiHost } from "../../utils/ApiConfig";


import logger from "../../utils/logger";
const BusinessList = () => {
  const { accessToken } = useAuth();
  const { userId } = useAuth();
  const [businesses, setBusinesses] = useState([]);
  let navigate = useNavigate();

  var data = [];
  const itemsPerPage = 10;

  useEffect(() => {
    const getBusinesses = async () => {
      try {
        const response = await axios
          .post(
            ApiHost + "/business/list",
            {
              user_id: userId,
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((response) => {
            const receivedBusinesses = response.data;
            data = [];
            receivedBusinesses.forEach((business) => {
              const address =
                business.Data.Street +
                " " +
                business.Data.Building +
                (business.Data.Number ? "/" + business.Data.Number : "") +
                ", " +
                business.Data.PostCode +
                " " +
                business.Data.City;
              data.push({
                Firma: business.Name,
                Adres: address,
                NIP: business.NIP,
                Action: business.Id,
              });
            });
            setBusinesses(data);
          })
          .catch((error) =>
            logger.error("Błąd pobierania listy powiązanych firm: ", error)
          );
      } catch (error) {
        logger.error("Błąd pobierania listy powiązanych firm: ", error);
      }
    };

    getBusinesses();
  }, [userId, accessToken]);

  return (
    <div className="card container-fluid shadow ms-4 px-4 py-3 w80">
      <div className="d-flex flex-column w-100 mb-2">
        <div className="d-flex flex-row">
          <div>
            W tym widoku możesz zarządzać listą firm, które reprezentujesz lub
            reprezentują Ciebie w procesie obsługi wniosku.
          </div>
          <div className="ms-auto">
            <button
              className="btn btn-primary w9 h2"
              onClick={() => {
                navigate("/business/add", { replace: true });
              }}
            >
              Dodaj
            </button>
          </div>
        </div>
      </div>
      <DataTable
        data={businesses}
        itemsPerPage={itemsPerPage}
        columnCount={4}
        columnHeaders={["Firma", "Adres", "NIP", "Operacje"]}
        dataColumns={["Firma", "Adres", "NIP", "Action"]}
        initialSortColumn="Firma"
      />
    </div>
  );
};

export default BusinessList;


